import { useState } from "react";

interface CandidateForm {
  jobTypeId: string;
  name: string;
  formVersionId: string;
}

interface OverrideActionProps {
  candidateForms: CandidateForm[];
  onOverride: (formVersionId: string, reason: string) => Promise<void>;
}

export function OverrideAction({
  candidateForms,
  onOverride,
}: OverrideActionProps) {
  const [selectedFormVersionId, setSelectedFormVersionId] = useState("");
  const [reason, setReason] = useState("");

  const isValid = selectedFormVersionId !== "" && reason.length >= 10;

  return (
    <div className="override-action">
      <h4>Manual form override</h4>
      <select
        role="combobox"
        value={selectedFormVersionId}
        onChange={(e) => setSelectedFormVersionId(e.target.value)}
      >
        <option value="">Select a form...</option>
        {candidateForms.map((f) => (
          <option key={f.formVersionId} value={f.formVersionId}>
            {f.name}
          </option>
        ))}
      </select>
      <textarea
        placeholder="Reason for override (min 10 characters)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <button
        disabled={!isValid}
        onClick={() => void onOverride(selectedFormVersionId, reason)}
      >
        Override &amp; advance
      </button>
    </div>
  );
}
